import React from 'react';
import { motion } from 'framer-motion';
interface WhatIncludesProps {
  onCTAClick: () => void;
}
export function WhatIncludes({
  onCTAClick
}: WhatIncludesProps) {
  const steps = [{
    number: '01',
    title: 'Evaluación inicial con el geronte',
    description: 'Protocolo de primera consulta adaptado a la población mayor.'
  }, {
    number: '02',
    title: 'Conceptualización del caso',
    description: 'Sistema para formular el caso clínico integrando las variables propias del envejecimiento.'
  }, {
    number: '03',
    title: 'Vínculo terapéutico con gerontes',
    description: 'Cómo construir y sostener el vínculo con adultos mayores que presentan resistencia, desconfianza o silencios.'
  }, {
    number: '04',
    title: 'Intervención en duelo y pérdidas',
    description: 'Protocolo para acompañar procesos de duelo en adultos mayores.'
  }, {
    number: '05',
    title: 'Intervención en deterioro cognitivo leve',
    description: 'Sistema para trabajar psicológicamente con gerontes que presentan deterioro cognitivo leve sin patología demencial.'
  }, {
    number: '06',
    title: 'Trabajo con la familia del geronte',
    description: 'Protocolo para intervenir con el entorno familiar.'
  }, {
    number: '07',
    title: 'Intervención en contexto institucional',
    description: 'Sistema para trabajar en geriátricos, residencias o instituciones.'
  }, {
    number: '08',
    title: 'Cierre del proceso terapéutico',
    description: 'Protocolo de cierre adaptado a la población mayor.'
  }];
  return <section className="w-full py-16 md:py-24 bg-[#faf9f7]" data-id="element-147">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-149">
          <h2 className="text-3xl md:text-4xl font-bold text-[#14505c] mb-4" data-id="element-150">
            QUÉ INCLUYE KIT PSICOLOGÍA EN GERONTES
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto" data-id="element-151">
            Todo lo que necesitás para estructurar el proceso terapéutico con
            adultos mayores desde la primera consulta hasta el cierre del
            tratamiento.
          </p>
        </motion.div>

        <div className="mb-8" data-id="element-152">
          <div className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-153">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.05
          }} className="bg-white p-4 md:p-6 rounded-lg shadow-md border-l-4 border-[#d97706]" data-id="element-154">
                <div className="flex flex-col sm:flex-row items-start gap-2 sm:gap-4" data-id="element-155">
                  <span className="text-2xl md:text-3xl font-bold text-[#d97706] flex-shrink-0" data-id="element-156">
                    {step.number}
                  </span>
                  <div data-id="element-157">
                    <h4 className="text-base md:text-lg font-bold text-[#14505c] mb-1 md:mb-2" data-id="element-158">
                      {step.title}
                    </h4>
                    <p className="text-gray-600 text-xs md:text-sm" data-id="element-159">
                      {step.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-160">
          <button onClick={onCTAClick} className="bg-[#d97706] hover:bg-[#b45309] text-white font-bold text-lg px-8 py-4 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl" data-id="element-161">
            SÍ, QUIERO EL KIT AHORA
          </button>
        </div>
      </div>
    </section>;
}